/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSmartphoneIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-smartphone"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.88 23.8Q5.75 23.8 4.99 23.04Q4.22 22.27 4.22 21.15L4.22 2.85Q4.22 1.75 5 0.97Q5.78 0.2 6.88 0.2L17.07 0.2Q18.2 0.2 18.96 0.96Q19.73 1.73 19.73 2.85L19.73 5.7Q20.23 5.92 20.51 6.38Q20.8 6.83 20.8 7.35L20.8 9.3Q20.8 9.82 20.51 10.28Q20.23 10.72 19.73 10.95L19.73 21.15Q19.73 22.27 18.96 23.04Q18.2 23.8 17.07 23.8ZM11.97 6.47Q11.97 6.47 12.25 6.47Q12.53 6.47 12.91 6.09Q13.3 5.7 13.3 5.15Q13.3 4.6 12.91 4.21Q12.53 3.83 11.97 3.83Q11.43 3.83 11.04 4.21Q10.65 4.6 10.65 5.15Q10.65 5.7 11.04 6.09Q11.43 6.47 11.97 6.47Z" fill={color} />
    </svg>
  );
}
